/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Po_Field_Closed_LinesInputs */

const en_po_field_closed_lines = /** @type {(inputs: Po_Field_Closed_LinesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lines closed`)
};

/**
* | output |
* | --- |
* | "Lines closed" |
*
* @param {Po_Field_Closed_LinesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_field_closed_lines = /** @type {((inputs?: Po_Field_Closed_LinesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Field_Closed_LinesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_field_closed_lines(inputs)
});